/*
 * @Author: Liux
 * @Date: 2019-11-21 06:41:20
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 16:50:02
 */
import { Component, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'ad-line-loading',
  templateUrl: './ad-line-loading.component.html',
  styleUrls: ['./ad-line-loading.component.scss'],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdLineLoadingComponent),
    },
  ],
})
export class AdLineLoadingComponent implements OnInit, ControlValueAccessor {
  //#region ngModel support
  private _value: number;

  get value() {
    return this._value;
  }
  set value(val: number) {
    let isChange = false;
    if (val > 100) {
      if (this._value < 100) {
        this._value = 100;
        isChange = true;
      }
    } else if (val < 0) {
      if (this._value > 0) {
        this._value = 0;
        isChange = true;
      }
    } else {
      this._value = val;
      isChange = true;
    }
    if (isChange) {
      this.valueChange(val);
      this.valueOnChange();
    }
  }

  valueChange = (val: number) => {};
  valueTouch = () => {};

  writeValue(obj: any): void {
    this._value = obj;
    this.valueOnChange();
  }
  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  //#endregion
  constructor() {}

  currentValue = 0;

  valueOnChange() {
    if (this.currentValue < this.value) {
      this.currentValue = this.value;
    }
  }

  ngOnInit() {}
}
